module.exports = __webpack_public_path__ + "img/sulv_0.b0802a3f.jpg";